module.exports = __webpack_public_path__ + "img/01_bohle.ce6d379a.jpeg";